export const LETTER = {
  ALEF: 'א', BET: 'ב', GIMMEL: 'ג', DALET: 'ד', HEH: 'ה', VAV: 'ו', ZAYIN: 'ז',
  CHET: 'ח', TET: 'ט', YUD: 'י', KAF: 'כ', END_KAF: 'ך', LAMED: 'ל', MEM: 'מ',
  END_MEM: 'ם', NUN: 'נ', END_NUN: 'ן', SAMECH: 'ס', AYIN: 'ע', PEH: 'פ', END_PEH: 'ף',
  TZADI: 'צ', END_TZADI: 'ץ', KUF: 'ק', RESH: 'ר', SHIN: 'ש', TAV: 'ת'
}
export const NIKUD = {
  HATAF_SEGOL: 'ֱ', HATAF_PATAH: 'ֲ', HATAF_QAMATZ: 'ֳ', HIRIQ: 'ִ', TSERE: 'ֵ', SEGOL: 'ֶ',
  PATAH: 'ַ', QAMATZ: 'ָ', SIN_DOT: 'ׂ', SHIN_DOT: 'ׁ', HOLAM: 'ֹ', DAGESH: 'ּ',
  QUBUTZ: 'ֻ', SHEVA: 'ְ', QAMATZ_QATAN: 'ׇ'
}
export const METEG = 'ֽ'
const ALL_NIKUD_REGEX = new RegExp('[' + Object.values(NIKUD).join('') + METEG + ']', 'g')
const NON_HEBREW_REGEX = new RegExp('[^' + Object.values(LETTER).join('') + Object.values(NIKUD).join('') + ']', 'g')

export function stringWithoutNikud(s) { // note that a meteg is ALSO removed (esp. for user dictionary 'originals')
  if (s)
    return s.replace(ALL_NIKUD_REGEX, '')
}

export function stringWithoutMeteggedLetters(s) { // for abbreviation expander (for now)
  return s.replace(new RegExp('[^' + METEG + '](?!' + METEG + ')', 'g'), '')
    .replace(new RegExp('[<>]' + METEG, 'g'), '')
    .replace(new RegExp('(.)' + METEG, 'g'), '$1')
}

export function onlyHebrew(s) {
  return s.replace(NON_HEBREW_REGEX, '')
}

function currentLetterValid(letter) {
  return letter
}

export function getCurrentLetterSin(letter) {
  var sin = false
  if (currentLetterValid(letter)) { // for computed properties defined before populating
    sin = letter.includes(NIKUD.SIN_DOT)
  }
  return sin
}


export function getCurrentLetterDagesh(letter) {
  var hasDagesh = false
  if (currentLetterValid(letter)) { // for computed properties defined before populating
    hasDagesh = letter.includes(NIKUD.DAGESH)
  }
  return hasDagesh
}

const VAV_WITH_HOLAM_OR_HATAF_ARRAY = [NIKUD.HOLAM, NIKUD.HATAF_PATAH, NIKUD.HATAF_QAMATZ, NIKUD.HATAF_SEGOL].map(
  n => LETTER.VAV + n
)

export function getLetterWithReversedDageshFromLetterArray(letter) {
  var original = letter
  var indexInLetterForDagesh = (getCurrentLetterSin(letter)
    || (original.includes(NIKUD.SHIN_DOT))) ? 2 : 1
  return getCurrentLetterDagesh(letter)
    ? original.replace(NIKUD.DAGESH, '')
    : (VAV_WITH_HOLAM_OR_HATAF_ARRAY.includes(letter))
      ? LETTER.VAV + NIKUD.DAGESH // no dagesh WITH cholam/chataf on vav
      : original.slice(0, indexInLetterForDagesh) + NIKUD.DAGESH + original.slice(indexInLetterForDagesh)
}
